module.exports = __webpack_public_path__ + "img/result.e4838d70.gif";